import { render, staticRenderFns } from "./FloorTypes.vue?vue&type=template&id=ea6a23ba&"
import script from "./FloorTypes.vue?vue&type=script&lang=js&"
export * from "./FloorTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports